import SendForm from "../sendForm/sendForm";

export const AdminObject = () => {
    return (
        <>
            <SendForm />
        </>
    )    
}

export default AdminObject;